<template>
  <section>
    <el-col
      v-if="topButtonList != null && topButtonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-input
            v-model="filters.ApplicantName"
            placeholder="姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.CompanyName"
            placeholder="公司名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.PhoneNumber"
            placeholder="手机号码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.ApplyAwardTypeName">
            <el-option label="--请选择领奖类型--" value="" key=""></el-option>
            <el-option
              v-for="item in applyAwardTypeList"
              :label="item.Name"
              :value="item.Name"
              :key="item.Name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="filters.ActivityId"
            placeholder="请输入活动名称"
            :loading="loadingActivityName"
            filterable
            clearable
            remote
            reserve-keyword
            :remote-method="remoteMethod"
            @change="handleActName"
          >
            <el-option
              v-for="item in activityList"
              :key="item.ActivityId"
              :label="item.ActivityName"
              :value="item.ActivityId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-for="item in topButtonList" v-bind:key="item.id">
          <el-button
            v-prevent-re-click
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="tabData"
      border=""
      v-loading="listLoading"
      ref="table"
      style="width: 100%"
    >
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column
        prop="Number"
        label="奖项编号"
        width="60"
      ></el-table-column>
      <el-table-column
        prop="CompanyName"
        label="企业名称"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="ApplicantName"
        label="领奖人姓名"
        width="100"
      ></el-table-column>
      <el-table-column prop="" label="领奖人类型" width="100"
        ><template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.Type == 0">领奖人</el-tag>
          <el-tag type="info" v-else>陪同人</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="PhoneNumber"
        label="手机号码"
        width="140"
      ></el-table-column>
      <el-table-column prop="Email" label="邮箱" width=""></el-table-column>
      <el-table-column prop="Position" label="职位" width=""></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        width="160"
      ></el-table-column>
      <el-table-column
        prop="ApplyAwardTypeNames"
        label="奖项"
        width=""
      ></el-table-column>
      <el-table-column
        prop="OwnerUserName"
        label="归属人"
        width=""
      ></el-table-column>
      <el-table-column prop="" label="状态" width="">
        <template slot-scope="scope">
          <el-switch
            @change="enabledChange(scope)"
            v-model="scope.row.IsEnabled"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
          <!-- <el-tag type="success" v-if="scope.row.IsEnabled">有效</el-tag>
          <el-tag type="danger" v-else>无效</el-tag> -->
        </template>
      </el-table-column>

      <el-table-column prop="" label="是否同步" width=""
        ><template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.IsSync">是</el-tag>
          <el-tag type="info" v-else>否</el-tag>
        </template></el-table-column
      >
      <el-table-column
        prop="ActivityName"
        label="活动名称"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" width="" v-if="tableButtonList.length > 0">
        <template slot-scope="scope">
          <span
            v-for="item in tableButtonList"
            :key="item.id"
            style="padding-left: 10px"
          >
            <el-button
              type="text"
              v-bind:key="item.id"
              v-prevent-re-click
              v-if="!item.IsHide"
              @click="callFunc(item, scope.row)"
              >{{ item.name }}</el-button
            >
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.PageIndex"
        :page-size="filters.PageSize"
        :total="filters.total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!-- 新增客户用户 -->
    <el-dialog
      title="新增/编辑"
      :visible.sync="addFormVisible"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
      >
        <el-form-item prop="CompanyName" label="公司名称">
          <el-select
            v-model="ruleForm.CompanyName"
            placeholder="请输入公司名称"
            :loading="loadingCompanyName"
            filterable
            clearable
            remote
            reserve-keyword
            :remote-method="companyRemoteMethod"
            style="width: 100%"
          >
            <el-option
              v-for="item in companyList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="ApplyAwardTypeNameArr" label="奖项">
          <el-checkbox-group v-model="ruleForm.ApplyAwardTypeNameArr" disabled>
            <el-checkbox
              v-for="item in applyAwardTypeList"
              :label="item.Name"
              :key="item.Name"
              >{{ item.Name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item prop="Type" label="类型">
          <el-radio-group v-model="ruleForm.Type">
            <el-radio :label="0">领奖人</el-radio>
            <el-radio :label="1">陪同人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="ApplicantName" label="姓名">
          <el-input
            placeholder="姓名"
            v-model="ruleForm.ApplicantName"
            clearable
            :disabled="isEdit"
          ></el-input>
        </el-form-item>
        <el-form-item prop="Position" label="职务">
          <el-input
            placeholder="职务"
            v-model="ruleForm.Position"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="PhoneNumber" label="手机号码">
          <el-input
            placeholder="手机号码"
            v-model="ruleForm.PhoneNumber"
            clearable
            :disabled="isEdit"
          ></el-input>
        </el-form-item>
        <el-form-item prop="Email" label="邮箱">
          <el-input
            placeholder="邮箱"
            v-model="ruleForm.Email"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="OwnerUserIds"
          label="归属人"
          v-if="ruleForm.IsShowOwners"
        >
          <el-select
            v-model="ruleForm.OwnerUserIds"
            placeholder="归属人"
            multiple
            @change="ownerChange"
            style="width: 100%"
          >
            <el-option
              v-for="item in userNameList"
              :label="item.LoginName"
              :value="item.UserId"
              :key="item.UserId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提 交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      :title="syncInfo.Title"
      :visible.sync="syncFormVisible"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleSyncClose"
    >
      <p v-for="(item, i) in syncInfo.Msgs" :key="i">{{ item }}</p>
    </el-dialog>
  </section>
</template>

<script>
import {
  getApplyAwardList,
  getActivityList,
  getApplyAwardTypeList,
  addOrUpdApplyAward,
  enabledApplyAward,
  getActivityInfo,
  syncApplyAward,
  getApplyAwardById,
  getUserListByDepId,
  getCompanyNames,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'

export default {
  data() {
    return {
      syncInfo: {
        Msgs: [],
        Title: '',
      },
      userNameList: [],
      isEdit: false,
      listLoading: false,
      buttonList: [],
      topButtonList: [],
      tableButtonList: [],
      editLoading: false,
      filters: {
        CompanyName: '',
        PhoneNumber: '',
        ActivityId: '',
        ApplyAwardTypeName: '',
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      tabData: [], // 列表绑定数据
      addFormVisible: false, // 新增弹框
      syncFormVisible: false,
      applyAwardTypeList: [],
      companyList: [],
      activityList: [], // 适用活动
      loadingActivityName: false, // 适用活动 加载效果
      loadingCompanyName: false,
      // 新增弹窗数据
      ruleForm: {
        CompanyName: '',
        ApplicantName: '',
        Position: '',
        PhoneNumber: '',
        Email: '',
        ApplyAwardTypeNames: '',
        ApplyAwardTypeNameArr: [],
        ActivityId: '',
        ActivityName: '',
        Type: 0,
        OwnerUserIds: [],
        OwnerUserId: '',
        IsShowOwners: false,
      },
      rules: {
        PhoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号' },
        ],
        CompanyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '公司名称长度在1到50个字符',
            trigger: 'blur',
          },
        ],
        ApplicantName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '姓名长度在1到50个字符',
            trigger: 'blur',
          },
        ],
        Position: [{ required: true, message: '请输入职位', trigger: 'blur' }],
        Email: [{ required: true, message: '请输入Email', trigger: 'blur' }],
        // ApplyAwardTypeNames: [
        //   {
        //     required: true,
        //     message: '请选择奖项',
        //     trigger: 'change',
        //   },
        // ],
        ActivityId: [
          { required: true, message: '请选择适用活动', trigger: 'change' },
        ],
      },
    }
  },
  components: {
    // Toolbar
  },
  methods: {
    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },

    // 下载名单
    handleExport() {
      const token = window.localStorage.getItem('Token')
      const url = `${process.env.VUE_APP_BASE_API}/api/ApplyAward/export`
      var xhr = new XMLHttpRequest()
      var params = JSON.stringify(this.filters)
      xhr.open('post', url, true)
      xhr.responseType = 'blob' // 返回类型blob
      xhr.setRequestHeader('Authorization', 'Bearer ' + token) // 携带token校验
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response
          var reader = new FileReader()
          reader.readAsDataURL(blob) // 转换为base64
          reader.onload = function (e) {
            var a = document.createElement('a') // 创建一个a标签用于下载
            a.download = '获奖报名.xls' //文件名
            a.href = e.target.result
            a.click()
            $(a).remove()
          }
        }
      }
      xhr.send(params) // 发送ajax请求
    },

    // 按钮点击事件传值
    callFunc(item, row) {
      this.currentRow = row
      this[item.Func].apply(this, item)
    },
    // 新增客户用户
    handleAdd() {
      if (!this.filters.ActivityId) {
        this.$message({
          message: '请先选择活动！',
          type: 'error',
        })
      } else {
        getActivityInfo(this.filters.ActivityId).then((res) => {
          console.log(res)
          if (res.data.success) {
            this.addFormVisible = true
            this.isEdit = false
          } else {
            this.$message({
              message: '已停止报名',
              type: 'error',
            })
          }
        })
      }
    },
    // 编辑
    handleUpdate() {
      getApplyAwardById(this.currentRow.Id).then((res) => {
        if (res.data.success) {
          this.ruleForm = res.data.response
          this.ruleForm.ApplyAwardTypeNameArr =
            this.ruleForm.ApplyAwardTypeNames.split(',')
          if (this.ruleForm.OwnerUserId) {
            this.ruleForm.OwnerUserIds = this.ruleForm.OwnerUserId.split(
              ','
            ).map((item) => {
              return Number(item)
            })
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })

      this.isEdit = true
      this.addFormVisible = true
    },

    // 适用的活动
    remoteMethod(query) {
      if (query !== '') {
        this.loadingActivityName = true
        setTimeout(() => {
          getActivityList(query).then((res) => {
            if (res.data.success) {
              this.activityList = res.data.response
              this.loadingActivityName = false
            }
          })
        }, 500)
      }
    },
    // 使用活动 选择事件，获取选择数据的值
    handleActName(val) {
      this.ruleForm.ActivityId = val
      this.ruleForm.ActivityName = val
        ? this.activityList.find((ele) => ele.ActivityId === val).ActivityName
        : ''
    },
    // 提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addOrUpdApplyAward(this.ruleForm).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
              this.handleClose()
              this.handleQuery()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }
          })
        } else {
          return false
        }
      })
    },
    handleClose() {
      this.addFormVisible = false
      this.$refs.ruleForm.resetFields()
    },
    handleSyncClose() {
      this.syncFormVisible = false
      this.syncInfo = {}
    },
    // 查询按钮——显示数据
    handleQuery() {
      this.listLoading = true
      getApplyAwardList(this.filters).then((res) => {
        if (res.data.success) {
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.tabData = res.data.response.data.filter((item) => {
            return item.ApplicantName !== ''
          })
          this.listLoading = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    // 归属人
    queryUserNameList() {
      getUserListByDepId({ departmentId: 8 }).then((res) => {
        if (res.data.success) {
          this.userNameList = res.data.response
        }
      })
    },
    handleSync() {
      if (!this.filters.ActivityId) {
        this.$message({
          message: '请先选择活动！',
          type: 'error',
        })
      } else {
        syncApplyAward(this.filters.ActivityId).then((res) => {
          console.log(res)
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: 'success',
            })
            this.handleQuery()
          } else {
            this.syncInfo = res.data.response
            this.syncFormVisible = true
          }
        })
      }
    },
    ownerChange() {
      this.ruleForm.OwnerUserId = this.ruleForm.OwnerUserIds.join(',')
      this.$forceUpdate()
    },
    // 适用的活动
    companyRemoteMethod(query) {
      if (query !== '') {
        this.loadingCompanyName = true
        setTimeout(() => {
          getCompanyNames(query).then((res) => {
            if (res.data.success) {
              this.companyList = res.data.response
              this.loadingCompanyName = false
            }
          })
        }, 500)
      }
    },
    enabledChange(scope) {
      enabledApplyAward({
        Id: scope.row.Id,
        IsEnabled: scope.row.IsEnabled,
      }).then((res) => {
        console.log(res)
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: 'success',
          })
          this.handleQuery()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
  },
  mounted() {
    this.handleQuery()
    this.queryUserNameList()
    getApplyAwardTypeList().then((res) => {
      if (res.data.success) {
        this.applyAwardTypeList = res.data.response
      }
    })
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    let buttonList = getButtonList(this.$route.path, routers)
    this.topButtonList = buttonList.filter((item) => {
      return item.ButtonType === 0
    })
    this.tableButtonList = buttonList.filter((item) => {
      return item.ButtonType === 1
    })
  },
}
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
.el-radio-button__inner,
.el-radio-group {
  line-height: 30px;
}
</style>
